import deepDiff from 'deep-diff';

import { ConsoleLogger } from '../types';
import { Action } from '../actions';
import { State } from '../state';

const formatStateDiff = (diff: deepDiff.Diff<State, State>): unknown[] => {
  switch (diff.kind) {
    case 'D':
      return [`- ${diff.path?.join('.')}`, diff.lhs];

    case 'E':
      return [`~ ${diff.path?.join('.')}`, diff.lhs, '>>', diff.rhs];

    case 'N':
      return [`+ ${diff.path?.join('.')}`, diff.rhs];

    case 'A':
      return [`~[] ${diff.path?.join('.')}`, `[${diff.index}]`, formatStateDiff(diff.item)];
  }
};

export const loggerMiddleware = (consoleLogger: ConsoleLogger, action: Action, previousState: State, newState: State) => {
  const stateDiff = deepDiff(previousState, newState);

  consoleLogger.debug('state', `Action: ${action.type}`, {
    payload: action.payload,
    stateDiff: stateDiff?.map((diffEntry) => formatStateDiff(diffEntry)),
    newState,
  });
};
